exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-c2e12cd8]  .dialog_box{border-radius:10px}.box[data-v-c2e12cd8]  .dialog_box .el-dialog__header{border-radius:10px 10px 0 0;background:#ecf4ff;color:#282828;font-weight:600;font-size:22px}.box .from_box[data-v-c2e12cd8]{padding:0 80px}.act-div[data-v-c2e12cd8]{border-radius:2px;border:1px solid #1890ff;-webkit-box-shadow:0px 2px 8px 0px rgba(108,142,174,.27);box-shadow:0px 2px 8px 0px rgba(108,142,174,.27)}", ""]);

// exports
